import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getPattern, getPatterns } from '../../reducers/patterns';

import {
    getActiveSewpat,
    getActiveSewpatId, getSewpatFigurineOverlay, getSewpatGalleryOverlay,
    getSewpats,
} from '../../reducers/sewpats';
import { getSewpatStripeCountToRender } from '../../reducers/ui.sewpatgalleries';
import Translatable from '../common/Translatable';
import Heading from '../heading/Heading';
import Picture from '../image/Picture';
import Gallery from '../stepper/SwipableGallery';
import Button from './CenteredPatternButton';
import GalleryOverlay from '../patterngalleries/GalleryOverlay';
import PatternRepeat from '../patterngalleries/PatternRepeat';
import PatternImage from '../image/Pattern';

const SewpatCarouselFigurine = ({ sewpats, activeSewpatId, sewpatCount, handleClick, patterns, figurineOverlay, overlayPath, imgUri }) => {
    const sewpat = sewpats[activeSewpatId];

    const patternIds = Object.keys(patterns);
    const hasPatterns = patternIds.length > 0;

    const StyledContainer = styled.div`
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: space-evenly;

        & .stolo-carousel-container {
          display: block;
          margin-left: auto;
          margin-right: auto;
          overflow: hidden;
          text-align: center;
       
          & img {
             width: 100%;
             max-width: ${Math.ceil(sewpat.figurineOverlay.width * 2)}px;
             max-height: ${sewpat.figurineOverlay.height}px;
             object-fit: contain;
             overflow: hidden;
             
           }
        }
        
        & .stolo-carousel-buttom-wrapper {
          padding-bottom: 2px;
        }
    `;

    const buildFiguriPage = (elementCount, sewpat, pattern, overlay, path) => {
        var elements = [];
        for (var i = 0; i < elementCount; i++) {
            const imgUri = pattern.thumbnails.gallery.url;
            elements.push(<div className='stolo-carousel-container' key={i}>
                <GalleryOverlay overlay={overlay} path={path} >
                    <PatternRepeat item={<PatternImage src={imgUri} />} />
                </GalleryOverlay>
                <Heading level={6} center text={pattern.title} />
                <div className='stolo-carousel-buttom-wrapper'>
                    <Button handleClick={handleClick} dense color='secondary' size='small'>
                        <Translatable message='PATTERN_BUTTON_LABEL' />
                    </Button>
                </div>
            </div>);
        }
        return elements;
    };

    const buildStepsToRender = () => {
        const sewpatPerPage = Math.ceil(sewpatCount);
        const pageCount = Math.ceil(7 / sewpatPerPage);

        var pages = [];
        var currentPattern = {};
        for (var i = 0; i < pageCount; i++) {
            const pattern = patternIds[i] ? patterns[patternIds[i]] : currentPattern;
            pages.push(<StyledContainer key={i}>
                {buildFiguriPage(sewpatPerPage, sewpat, pattern, figurineOverlay, overlayPath)}
            </StyledContainer>);
        }
        return pages;
    };

    const sewPat = sewpats[activeSewpatId];

    const getMaxSteps = () => 4;

    return !sewPat || !hasPatterns ? null : (
        <Gallery activeStep={0} maxSteps={getMaxSteps()}>
            {(activeStep, handleStepChange) => (
                <React.Fragment>
                    <Gallery.Steps
                        activeStep={activeStep}
                        handleStepChange={handleStepChange}
                        className={'stolo-swipable-gallery-container'}
                    >
                        {buildStepsToRender()}
                    </Gallery.Steps>
                </React.Fragment>
            )}
        </Gallery>
    );
};

const makeMapStateToProps = initialstate => {
    const sewpats = getSewpats(initialstate);

    const mapStateToProps = state => (
        {
            sewpats,
            activeSewpatId: getActiveSewpatId(state),
            sewpatCount: getSewpatStripeCountToRender(state),
            patterns: getPatterns(state),
            figurineOverlay: getSewpatFigurineOverlay(state),
            overlayPath: `schnittmuster/${getActiveSewpatId(state)}`,
        }
    );
    return mapStateToProps;
};

export default connect(makeMapStateToProps)(SewpatCarouselFigurine);



// WEBPACK FOOTER //
// ./src/components/sewpat/SewpatFigurineCarousel.js